import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import {EmptyRecord} from "../../utils/PageUtility";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import { PrimaryLabel, DangerLabel } from "../../utils/LabelPanel"

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    paragraph: {
        color: '#999999',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0,
        fontSize: '0.85em'
    },
    heading: {
        color: '#3C4858',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0
    },
    headerContainer:{
        display: 'flex',
        padding: '10px 0',
        justifyContent: 'space-around'
    }
};

const TableStructure = ({classes, records}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell>S/N</TableCell>
                <TableCell>Departure Code</TableCell>
                <TableCell>Destination Code</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell component="th">{1 + key}</TableCell>
                        <TableCell component="th">{item.DepartureCode}</TableCell>
                        <TableCell>{item.DestinationCode}</TableCell>
                    </TableRow>
                );
            })}

        </TableBody>
    </Table>
);

function AirlineRouteTable(props) {
    let { classes,
        routes,
        airline,
    } = props;
    const routesLength = routes.length;
    return (
        <div>
            <Card>
                <CardHeader color="success" stats icon>
                    <div style={styles.headerContainer}>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Airline
                            </p>
                            <h4 style={styles.heading}>
                                {airline.Airline}
                            </h4>
                        </div>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Airline Code
                            </p>
                            <h4 style={styles.heading}>
                                {airline.AirlineCode}
                            </h4>
                        </div>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Customer AIN
                            </p>
                            <h4 style={styles.heading}>
                                {airline.CustomerAin}
                            </h4>
                        </div>
                        <div style={styles.paragraph}>
                            <p style={styles.paragraph}>
                                Pull Manifest
                            </p>
                            <h4 style={styles.heading}>
                                {(airline.IsPullManifest) ?
                                    <PrimaryLabel message={'YES'}/> : <DangerLabel message={'NO'}/>
                                }
                            </h4>
                        </div>
                    </div>
                </CardHeader>
            </Card>
            {
                routesLength > 0 &&
                <TableStructure records={routes} classes={classes}/>
            }
            {
                routesLength === 0 &&
                <EmptyRecord message={'No route for airline.'}/>
            }
        </div>
    );
}

export default withStyles(styles)(AirlineRouteTable)



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/ViewAirlineRoutes.js